/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from 'react';
import { useAuthMe } from '../services/queries';
import { INTERNAL_APPS } from '../helper/constants';

// Global flag to ensure refetch only happens once across all hook instances
let hasRefetched = false;

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [originUsername, setOriginUsername] = useState('');
  const [username, setUsername] = useState('');
  const [userImage, setUserImage] = useState('');
  const [position, setPosition] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState([]);
  const [filteredApps, setFilteredApps] = useState(INTERNAL_APPS);
  const hasInitialized = useRef(false);

  const { isLoading, data, error, refetch, status } = useAuthMe();

  const checkPermissionElement = (par) => {
    if (data?.data?.permissions) {
      return permissions.includes(par);
    }
  };

  useEffect(() => {
    // Only run once per app lifecycle, not once per component instance
    if (hasInitialized.current || hasRefetched) {
      return;
    }

    hasInitialized.current = true;
    hasRefetched = true;

    const token = localStorage.getItem('token');
    if (token) {
      refetch();
      setIsAuthenticated(true);
    } else {
      localStorage.removeItem('token');
      setIsAuthenticated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  useEffect(() => {
    if (data && data.data) {
      const dat = data.data;
      setOriginUsername(dat?.username || '');
      setUsername(dat?.full_name || '');
      setPosition(dat?.profile?.position || '');
      setUserImage(dat?.picture_url || '');
      setRole(dat?.roles || []);
      setPermissions(dat?.permissions || []);
      const filteredApps = INTERNAL_APPS.filter(
        (app) => app.id === '' || dat?.permissions.includes(app.id),
      );
      setFilteredApps(filteredApps);
    }
  }, [data]);

  const setAuth = (authStatus) => {
    setIsAuthenticated(authStatus);
    if (!authStatus) {
      localStorage.removeItem('token');
      setUsername('');
      setRole([]);
      setUserImage('');
      setPosition('');
      setPermissions([]);
      // Reset the global flag so /me can be fetched on next login
      hasRefetched = false;
      hasInitialized.current = false;
    } else {
      // When setting auth to true (after login), trigger /me fetch
      hasRefetched = true;
      hasInitialized.current = true;
      refetch();
    }
  };

  return {
    isAuthenticated,
    username,
    position,
    permissions,
    role,
    status,
    setAuth,
    setUsername,
    setRole,
    originUsername,
    userImage,
    isLoading,
    filteredApps,
    checkPermissionElement,
    refetchUser: refetch,
  };
};

export default useAuth;
